import { createActions } from "../../utils/reduxsauce";

const { Types, Creators } = createActions(
  {
    getAllCee: { args: ["payload"], meta: { async: true } },
    getAllCeeTasks: { args: ["payload"], meta: { async: true } },
    getAllCeeSpots: { args: ["payload"], meta: { async: true } },
    getAllMeets: { args: ["payload"], meta: { async: true } },
    getCee: { args: ["payload"], meta: { async: true } },
    setCee: { args: ["payload"], meta: { async: true } },
    addCee: { args: ["payload"], meta: { async: true } },
    deleteCee: { args: ["payload"], meta: { async: true } },
    editCee: { args: ["payload"], meta: { async: true } },
    showDialog: { args: [], meta: { async: false } },
    showDeleteDialog: { args: [], meta: { async: false } },
    resetDialog: { args: [], meta: { async: false } },
  },
  {
    prefix: "@app/Cee/",
  }
);
export const ActionTypes = Types;
export default Creators;
